import React, { useEffect } from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as searchFiltersSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import { effects as searchPageEffects } from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as petsSelectors } from '@rover/react-lib/src/redux/ducks/pets.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { ColorfulPerfectMatchSectionViewed } from './analyticsEvents';
import ColorfulPerfectMatchSection from './ColorfulPerfectMatchSection';

export type Props = {
  onSubmit: () => void;
  onVisibilityChange?: (isVisible: boolean) => void;
};

const effects = {
  fireSearch: searchPageEffects.fireSearch,
  updateFiltersAndFireSearch: searchPageEffects.updateFiltersAndFireSearchOnChange,
};

const selector = (state) => ({
  searchFilters: searchFiltersSelectors.getFilters(state),
  serviceTypeFilterOptions: searchFiltersSelectors.getServiceTypeFilterOptions(state),
  pets: petsSelectors.getPets(state),
  isUserAuthenticated: currentUserSelectors.isAuthenticated(state),
  petSizeBuckets: searchSelectors.getSearchDogSizeBuckets(state),
  weightUnit: searchSelectors.getSearchWeightUnit(state),
  locale: frontendConfigurationSelectors.getLanguage(state),
});

const ColorfulPerfectMatchSectionContainer = (props: Props): JSX.Element => {
  useEffect(() => {
    emitAnalyticsEvent(new ColorfulPerfectMatchSectionViewed());
  }, []);

  return (
    <Connect selector={selector} effects={effects}>
      {(connectedProps) => <ColorfulPerfectMatchSection {...connectedProps} {...props} />}
    </Connect>
  );
};

export default ColorfulPerfectMatchSectionContainer;
